export default function Relation (options = {}) {
  const {explicit = false} = options

  return {
    key: Math.random().toString(36).substr(2, 10),
    explicit
  }
}

export function compareDocumentPosition (a, b) {
  const {
    DOCUMENT_POSITION_PRECEDING,
    DOCUMENT_POSITION_FOLLOWING
  } = document

  if (a === b) {
    return 0
  }

  const position = a.$el.compareDocumentPosition(b.$el)

  if (position & DOCUMENT_POSITION_PRECEDING) {
    return 1
  }

  if (position & DOCUMENT_POSITION_FOLLOWING) {
    return -1
  }

  return 0
}

export function indexWithin (array, component) {
  let lo = 0
  let hi = array.length - 1

  while (lo <= hi) {
    const mid = lo + (hi - lo) / 2 | 0

    switch (compareDocumentPosition(component, array[mid])) {
      case -1:
        hi = mid - 1
        break
      case 1:
        lo = mid + 1
        break
      default:
        return mid
    }
  }

  return lo
}

export const HasOne = (relation, key = 'owns') => {
  return !relation ? {} : {
    data () {
      return {
        [key]: null
      }
    },
    provide () {
      return !relation.explicit && {
        [relation.key]: this
      }
    },
    created () {
      this.relations = this.relations || {}
      this.relations[relation.key] = {
        register: member => {
          if (this.owns !== member) {
            this[key] = member
          }
        },
        unregister: member => {
          if (this.owns === member) {
            this[key] = null
          }
        }
      }
    }
  }
}

export const HasMany = (relation, key = 'owns') => {
  return !relation ? {} : {
    data () {
      return {
        [key]: []
      }
    },
    provide () {
      return !relation.explicit && {
        [relation.key]: this
      }
    },
    created () {
      this.relations = this.relations || {}
      this.relations[relation.key] = {
        register: member => {
          const index = indexWithin(this[key], member)

          if (this[key][index] !== member) {
            this[key].splice(index, 0, member)
          }
        },
        unregister: member => {
          const index = this[key].indexOf(member)

          if (this[key][index] === member) {
            this[key].splice(index, 1)
          }
        }
      }
    }
  }
}

export const MemberOf = (relation, key = 'owner') => {
  return !relation ? {} : {
    inject: relation.explicit ? {} : {
      [relation.key]: {
        name: relation.key,
        default: null
      }
    },
    props: !relation.explicit ? {} : {
      [key]: {
        type: Object,
        default: null
      }
    },
    data () {
      const data = {
        id: null
      }

      if (!relation.explicit) {
        data[key] = this[relation.key] || null
      }

      return data
    },
    created () {
      if (this[key] && this.id === null) {
        this.id = this.$identifier()
      }
    },
    mounted () {
      if (this[key]) {
        this[key].relations[relation.key].register(this)
      }
    },
    /**
     * NB: De-registration of the member MUST happen before the "destroyed"
     * lifecycle event. This due to the fact that the member will have been
     * removed from the DOM tree by the time the "destroyed" hook is invoked.
     */
    beforeDestroy () {
      if (this[key]) {
        this[key].relations[relation.key].unregister(this)
      }
    }
  }
}
